export const SET_FEEDBACK_DASHBOARD_LOADING = 'SET_FEEDBACK_DASHBOARD_LOADING'
export const SET_FEEDBACK_DASHBOARD = 'SET_FEEDBACK_DASHBOARD'
export const SET_FEEDBACK_FILTER_CAMPAIGN = 'SET_FEEDBACK_FILTER_CAMPAIGN'